import DataTableCell from './DataTableCell.vue';
import DataTableHeading from './DataTableHeading.vue';
import DataTable from './DataTable.vue';
import DataTableLayout from './DataTableLayout.vue';

import Table from './Table.vue';
import PatientResults from './PatientResults.vue';

export { Table, DataTableCell, DataTableHeading, DataTable, DataTableLayout, PatientResults };
